import { z } from "zod"

export const CheckoutPricingSummarySchema = z
	.object({
		productBaseAmountCents: z.number().int().nonnegative(),
		feeAmountCents: z.number().int().nonnegative(),
		finalAmountDueCents: z.number().int().nonnegative(),
	})
	.meta({ id: "CheckoutPricingSummary" })

export type CheckoutPricingSummary = z.infer<typeof CheckoutPricingSummarySchema>
